<div class="section business-section">
    <h1 class="section-title">{{articleSectionDescription}}</h1>
    <div class="cat-menu">         
        <a routerLink="/section/{{articleSection}}" routerLinkActive="active">See all</a>					
    </div>
    <ng-container *ngFor="let newsArticle of newsArticles; index as i; first as isFirst">
        <csl-medium-post *ngIf="i<5" [newsArticle] = "newsArticle" [showSectionLabel] = false></csl-medium-post>
    </ng-container>
</div><!-- /.business-section -->